import React from "react";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

import Organizations from "./components/Organizations";
import Reports from "./components/Reports";
import Uploads from "./components/Uploads";
import Status from "./components/Status";
import { Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";

function AdminHome() {
  /*
    three sections:
    1. Get Organization Information (both )
    2. Get Submitted Reports
    3. Get Uploaded Files
    4. Status of Submission


    section 1: (need to change headers according to new csv file)

    a. Organization Name
    b. Certificate of Inclusion Number
    c. Primary Contact Name
    d. Address
    e. Phone Number
    f. Email Address
    g. Acres Enrolled
    h. Acres Adopted
    i. Acres Contributed
    j. Additional Explanation
    --- anticipate_updates ( upcoming_year_forecase table )

    k. conservation_measures ( need formating )
    l. conservation_measures_implementation
    m. partners_overlap
    n. supplemental_measures
    o. additional_supplemental_conservation_measures
    p. methods_effective_monitoring (need formating)
    q. monitoring_results_summary
    r. adaptive_management_triggered (needs formating)
    s. adaptive_management_actions
    t. supplemental_effective_monitoring (needs formating)
    u. general_comments

  */

  const [alignment, setAlignment] = React.useState("");

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  React.useEffect(() => {
    setAlignment("organizations");
  }, []);

  return (
    <>
      {/* nav bar tabs */}
      <div className="row">
        <Tabs align="center"
              isFitted="false"
              isLazy="true"
              size="md"
        >
          <TabList>
            <Tab>Organization Infromation</Tab>
            <Tab>Submitted Reports</Tab>
            <Tab>Submission Status</Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <Organizations />
            </TabPanel>
            <TabPanel>
              <Reports />
            </TabPanel>
            <TabPanel>
              <Status />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </>
  );
}

export default AdminHome;
